import { LISSpecimen } from "pwapi";

import { AccessionSpecimen } from "custom-models";

import SpecimenProtocolTags from "./SpecimenProtocolTags";

export const SpecimenProtocolBanner = ({
  specimen,
  specimens,
}: {
  specimen: LISSpecimen | AccessionSpecimen;
  specimens: Array<LISSpecimen | AccessionSpecimen>;
}) => {
  if (!specimen.protocols?.length) return null;

  return (
    <div className="WorkList__item--protocols">
      <h3>Protocols: &nbsp;</h3>
      <SpecimenProtocolTags
        dark={true}
        specimen={specimen}
        specimens={specimens}
      />
    </div>
  );
};

export default SpecimenProtocolBanner;
